import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    ClientName: {
        validations: []
      },
      Category: {
          validations: [
            { type: 'required', message: 'Please provide a selection' },
          ]
      },
      eventDate: {
        validations: [
          { type: 'required', message: 'Please provide an event date' },
          { type: 'dateinfuture', message: 'Event date must be in the future' }
        ]
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' },
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Phone Number:*',
          mapping: 'telNumber'
        }
      ]
    },
    {
      fields: [
        {
            type: 'text',
            size: 'Medium',
            label: 'Company/Group Name:',
            mapping: 'ClientName'
        }
    ]
  },
  {
    fields: [
        {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'SMG Location:*',
        options: [
          { label: 'Highlands - Arlington, TX ', value: 'Highlands - Arlington, TX ' },
          { label: 'Lincoln Square -  Arlington, TX', value: 'Lincoln Square - Arlington, TX' },
          { label: 'Bakersfield, CA', value: 'Bakersfield, CA' },
          { label: 'Chisholm Trail – Fort Worth, TX', value: 'Chisholm Trail – Fort Worth, TX' },
          { label: 'Colony, TX', value: 'Colony, TX' },
          { label: 'Duluth, GA', value: 'Duluth, GA' },
          { label: 'Marietta, GA', value: 'Marietta, GA' },
          { label: 'North Point, GA', value: 'North Point, GA' },
          { label: 'Pearland, TX', value: 'Pearland, TX' },
          { label: 'Plano, TX', value: 'Plano, TX' },
          { label: 'Rocklin, CA', value: 'Rocklin, CA' },
          { label: 'Royal Lane – Dallas, TX', value: 'Royal Lane – Dallas, TX' },
          { label: 'Seminole, FL', value: 'Seminole, FL' },
          { label: 'Simi Valley, CA', value: 'Simi Valley, CA' },
          { label: 'Spring Valley – Richardson, TX', value: 'Spring Valley – Richardson, TX' },
          { label: 'Sunset Walk – Orlando, FL', value: 'Sunset Walk – Orlando, FL' },
          { label: 'Tyler, TX', value: 'Tyler, TX' },
          { label: 'Wheaton, IL', value: 'Wheaton, IL' },
      ],
        mapping: 'Category'
    }
]
  },
  {
    fields: [
      {
        type: 'date-picker',
        size: 'Medium',
        label: 'Preferred Date:*',
        mapping: 'eventDate'
      }
    ]
  },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:',
            options: [
              { label: 'Business Meeting', value: 'Business Meeting' },
              { label: 'Movie Event', value: 'Movie Event' },
              { label: 'Independent Film Screening', value: 'Independent Film Screening' },
              { label: 'Movie Party', value: 'Movie Party' },
              { label: 'Other', value: 'Other' },
          ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Number of Attendees (Events require a minimum of 30 people):*',
            options: [
              { label: '30 – 50', value: '30 – 50' },
              { label: '50 – 75', value: '50 – 75' },
              { label: '75 – 100', value: '75 – 100' },
              { label: '100 or more', value: '100 or more' },
            ],
            mapping: 'plannedguestcount'
          }
        ]
},
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Information:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Studio Movie Grill Contact Form',
    formId: '1861',
    clientKey: 'D1AD6DC2-B2C0-44CB-882E-F676E2883354',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your request. We will respond within 24 hours and look forward to discussing your event.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
